<template>
  <div class="wrapper d-flex justify-end">
    <canvas
      id="signature-pad"
      ref="signaturePad"
      :width="$vuetify.breakpoint.smAndUp ? 500 : 300"
      :height="$vuetify.breakpoint.smAndUp ? 250 : 150"
    />
    <div class="undo">
      <v-icon @click="clear">
        mdi-close
      </v-icon>
    </div>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad';

export default {
  data() {
    return {
      signaturePad: null,
    };
  },
  mounted() {
    const canvas = this.$refs.signaturePad;
    this.signaturePad = new SignaturePad(canvas);
    this.signaturePad.toDataURL(); // save image as PNG
    this.signaturePad.toDataURL('image/jpeg'); // save image as JPEG
    this.signaturePad.toDataURL('image/svg+xml'); // save image as SVG
  },
  methods: {
    getSignatureImage() {
      return this.$refs.signaturePad.toDataURL();
    },
    clear() {
      this.signaturePad.clear();
    },
    isEmpty() {
      return this.signaturePad.isEmpty();
    },
  },
};
</script>

<style>
.wrapper {
  border: 1px solid grey;
}

.undo {
  margin-left:-25px;
}

</style>
